import _capitalize from "lodash/capitalize";
import { useMemo } from "react";
import useIsMobile from "../../../../../../hooks/device/useIsMobile.js";
import { useSearcherActivitiesProps } from "../../context/index.js";
import useSearcherActivitiesDefaultValues from "../../hooks/useSearcherActivitiesDefaultValues.js";
const usePassengersInput = ()=>{
    const props = useSearcherActivitiesProps();
    const { config  } = props ?? {};
    const { literals , onModal  } = config ?? {};
    const { passenger ='' , passengers ='' , passengersLabel ='' , passengersTitle: passengerModalLabel = '' , ageAtTravelTimeLabel ='' , acceptLabel =''  } = literals ?? {};
    const isMobile = useIsMobile();
    const commonProps = {
        name: 'passengers',
        label: passengersLabel,
        defaultValue: useSearcherActivitiesDefaultValues(props).passengers,
        literals: {
            adultLabel: passenger,
            adultsLabel: _capitalize(passengers),
            acceptLabel: acceptLabel
        }
    };
    const tooltipOptions = useMemo(()=>({
            strategy: onModal ? 'fixed' : undefined
        }), [
        onModal
    ]);
    if (isMobile) {
        return {
            ...commonProps,
            literals: {
                ...commonProps.literals,
                passengersLabel: passengerModalLabel,
                ageAtTravelTimeLabel: ageAtTravelTimeLabel
            }
        };
    }
    return {
        ...commonProps,
        columns: 4,
        literals: {
            ...commonProps.literals,
            passengerLabel: passengersLabel,
            passengerTitleLabel: passengerModalLabel
        },
        tooltipOptions
    };
};
export default usePassengersInput;

//# sourceMappingURL=usePassengersInput.js.map